import { Divider, Stack, ThemeProvider, Typography } from '@mui/material';
import AppRouter from './routes/AppRouter';
import useGetCompanyInfo from './hooks/useGetCompanyInfo';
import theme from './theme';

function ExceptionHandler({ error }) {
  return (
    <Stack p={5} spacing={3}>
      <Typography variant='h5' sx={{ color: 'red', fontWeight: 'bold' }}>
        에러 발생
      </Typography>
      <Divider />
      <Typography>{error?.message ? error.message : '알 수 없는 오류'}</Typography>
    </Stack>
  );
}

export default function App() {
  const companyData = useGetCompanyInfo();

  // 기기(User-Agent) 분기 없이 반응형 단일 화면을 사용한다.
  return (
    <ThemeProvider theme={theme}>
      <AppRouter companyData={companyData} ExceptionHandler={ExceptionHandler} />
    </ThemeProvider>
  );
}
